import React, { useEffect, useState } from "react";
import { getTravelDetailAPI } from "../../../Api/PanelAdminServices";
import { errorToast } from "../../../Utils/Toast/Toast";
import moment from "moment-jalaali";
import Style from './TravelDetailModal.module.scss'
const TravelDetailModal = ({ travelId }) => {
  const [travelDetailData, setTravelDetailData] = useState([]);
  useEffect(() => {
    getDataHandler();
  }, []);
  const getDataHandler = () => {
    getTravelDetailAPI(travelId, (res) => {
      if (res.status === 1) {
        setTravelDetailData(res.travel);
      } else {
        errorToast(res.message);
      }
    });
  };
  return (
    <div className={Style.ComponentHolder}>
      <section>
        <h2>اطلاعات راننده و ماشین</h2>
        <ul>
          <li>
            <p>
              نام راننده:
              <span>
                {travelDetailData.driver_name
                  ? travelDetailData.driver_name
                  : "در انتظار راننده!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              شماره راننده:
              <span>
                {travelDetailData.driver_phone
                  ? travelDetailData.driver_phone
                  : "در انتظار راننده!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              مدل و رنگ ماشین:
              <span>
                {travelDetailData.vehicle_model
                  ? `${travelDetailData.vehicle_model} ${travelDetailData.vehicle_color}`
                  : "در انتظار راننده!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              {" "}
              پلاک ماشین:
              <span>
                {travelDetailData.vehicle_plate
                  ? travelDetailData.vehicle_plate
                  : "در انتظار راننده!"}
              </span>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h2>اطلاعات مسافر</h2>
        <ul>
          <li>
            <p>
              نام مسافر:
              <span>
                {travelDetailData.user_name
                  ? travelDetailData.user_name
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              شماره مسافر:
              <span>
                {travelDetailData.user_phone
                  ? travelDetailData.user_phone
                  : "در انتظار!"}
              </span>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h2>اطلاعات سفر</h2>
        <ul>
          <li>
            <p>
              {" "}
              مبدا سفر:
              <span>
                {travelDetailData.routes_description
                  ? travelDetailData.routes_description.split("**")[0]
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              مقصد سفر:
              <span>
                {travelDetailData.routes_description
                  ? travelDetailData.routes_description.split("**")[1]
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              توضیحات سفر:
              <span>
                {travelDetailData.description
                  ? travelDetailData.description
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              هزینه سفر:
              <span>
                {travelDetailData.delivery
                  ? travelDetailData.delivery
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              هزینه راننده:
              <span>
                {travelDetailData.deliver
                  ? travelDetailData.deliver
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              وضعیت سفر:
              <span>
                {travelDetailData.deliver
                  ? travelDetailData.status === "0"
                    ? "منتظر تایید راننده"
                    : travelDetailData.status === "1"
                    ? "راننده در مسیر مبدأ"
                    : travelDetailData.status === "2"
                    ? "راننده در مبدأ است!"
                    : travelDetailData.status === "3"
                    ? "در مسیر مقصد!"
                    : travelDetailData.status === "4"
                    ? "اتمام سفر"
                    : travelDetailData.status === "-2"
                    ? "سفر لغو شده"
                    : travelDetailData.status === "-1"
                    ? "توسط راننده کنسل شد!"
                    : null
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              نوع پرداخت:
              <span>
                {travelDetailData.paid
                  ? travelDetailData.paid==="0"?'نقدی':'آنلاین'
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              زمان قبولی سفر:
              <span>
                {travelDetailData.accept_date
                  ? moment.unix(parseInt(travelDetailData.accept_date)).format("jYYYY/jM/jD----hh:mm:ss a")
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          <li>
            <p>
              زمان رسیدن راننده:
              <span>
                {travelDetailData.arrive_date
                  ? moment.unix(parseInt(travelDetailData.arrive_date)).format("jYYYY/jM/jD----hh:mm:ss a")
                  : "در انتظار!"}
              </span>
            </p>
          </li>
          {
            travelDetailData.cancel_date?<li>
            <p>
              زمان کنسلی:
              <span>
                {travelDetailData.cancel_date
                  ? moment.unix(parseInt(travelDetailData.cancel_date)).format("jYYYY/jM/jD----hh:mm:ss a")
                  : "در انتظار!"}
              </span>
            </p>
          </li>:null
          }
          
        </ul>
      </section>
    </div>
  );
};

export default TravelDetailModal;
